import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import Table, { buttonsStyle, longTextFormatter } from '../../../components/tables/table'
import { getTexts } from '../../../../api/text'
import { Button, Tooltip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { alertError } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function getData(texts) {
  let data = []
  for (let i = 0; i < texts.length; ++i) {
      const elem = {}
      elem.title = texts[i].title?.en
      elem.content = texts[i].content?.en || '---'
      elem.id = texts[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function TextsPage() {
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-text/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
    </>)
  }

  const columns = [
    { dataField: 'title', text: 'Title', sort: true },
    { dataField: 'content', text: 'Content', formatter: longTextFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getTexts().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get texts.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Texts list'/>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
        </CardBody>
      </Card>
    </>
  );
}
